import { axiosV3 } from "../../../Utils/Axios/axiosV3";

export const getSingleUserTicket = async (
  userToken: string,
  ticketId: string
) => {
  return axiosV3.get(`/user/ticket/${ticketId}`, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
